import {
  VIRTUAL_PAGE_EVENT,
  STATES_ERROR,
  STATES_VALID,
  STATES_INACTIVE,
  STATES_BLACKLIST,
  EVENT_ACTION_KO,
  EVENT_GA,
  EMAIL_ERROR,
} from './constants'

export default class {
  static pageSend = false

  static virtualPageSend = false

  /**
   *  Gets page errors
   * @param state
   * @param consumed
   * @returns {string|null}
   */
  static getVirtualPageError(state, consumed) {
    if (state === STATES_ERROR) return 'general-error'

    if (state === STATES_VALID && consumed) return 'product-escaned'

    if (state === (STATES_INACTIVE || STATES_BLACKLIST))
      return 'incidence'
    return null
  }

  /**
   *
   * @param error
   * @returns {*}
   */
  static getErrorFromService(error) {
    return error.data.details.find(
      err => err?.context.key === 'email',
    )
  }

  /**
   * return Event error Tag
   * @param eventCategory
   * @param error
   * @param isServer
   * @returns {{eventCategory, event, eventAction, eventLabel: string}}
   */
  static getEventError(eventCategory, error, isServer) {
    const hasError = isServer
      ? this.getErrorFromService(error)
      : error
    if (hasError) {
      this.pushEvent({
        eventCategory,
        eventAction: EVENT_ACTION_KO,
        eventLabel: EMAIL_ERROR,
        event: EVENT_GA,
      })
    }
  }

  /**
   * return Event error Tag for QRCodes
   * @param country
   * @param type
   */
  static getEventQRError(country, type) {
    this.pushEvent({
      virtualUrl: `/${country}/qr-scan/${type}/general-international`,
      virtualTitle: document.title,
      event: 'paginavirtual',
    })
  }

  /**
   * Returns getSubscriptionEvent Tag
   * @param eventCategory
   * @param eventAction
   * @param isSubscribed
   * @param points
   * @param email
   */
  static getSubscriptionEvent(
    eventCategory,
    eventAction,
    isSubscribed,
    points,
    email,
  ) {
    this.pushEvent({
      eventCategory,
      eventAction,
      eventLabel: isSubscribed ? 'yes' : 'no',
      eventValue: points,
      leadId: email,
      event: EVENT_GA,
    })
  }

  /**
   * Push page into GTM
   * @param country
   * @param language
   */
  static pushPage(country, language) {
    if (!this.pageSend) {
      this.pageSend = true
      this.pushEvent({
        user: { trafficType: '' },
        debug: { codeVersion: '' },
        page: { country, language },
      })
    }
  }

  /**
   * Push virtual page into GTM
   * @param state
   * @param country
   * @param consumed
   */
  static pushVirtualPage(state, country, consumed) {
    const error = this.getVirtualPageError(state, consumed)
    const virtualUrl = !error
      ? `${country}/entry/login`
      : `${country}/error/${error}`

    if (!this.virtualPageSend) {
      this.virtualPageSend = true
      this.pushEvent({
        virtualUrl,
        virtualTitle: document.title,
        event: VIRTUAL_PAGE_EVENT,
      })
    }
  }

  /**
   * Push Event to datalayer
   * @param data
   */
  static pushEvent(data) {
    if (window.dataLayer) {
      window.dataLayer.push(data)
    }
  }
}
